import { render, staticRenderFns } from "./Reserve.vue?vue&type=template&id=260a070c&scoped=true&lang=pug"
import script from "./Reserve.vue?vue&type=script&lang=js"
export * from "./Reserve.vue?vue&type=script&lang=js"
import style0 from "./Reserve.vue?vue&type=style&index=0&id=260a070c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260a070c",
  null
  
)

export default component.exports